import { observer } from 'mobx-react';
import { FC } from 'react';

import { Modal } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { AddNumberModalStep, PhoneNumbersStore } from '../../stores/phone-numbers.store';
import { PhoneNumberModel } from '@servicetitan/application-data/telecom';
import { NumberEdit } from './number-edit';
import { NumberSearch } from './number-search';
import { NumberSelect } from './number-select';
import { NumberConfirm } from './number-confirm';

export const AddEditNumber: FC<{
    id: string | undefined;
    campaignId?: number;
    hideSetCampaign?: boolean;
    allowIncomingSms?: boolean;
    addingCallExtension?: boolean;
    tfnDisabled?: boolean;
    onSave?(model: PhoneNumberModel): void;
    onStepBack?(): void;
}> = observer(props => {
    const [{ modalStep, closeModal }] = useDependencies(PhoneNumbersStore);

    if (!modalStep) {
        return null;
    }

    return (
        <Modal.Window open size={Modal.Sizes.S} onClose={closeModal}>
            {modalStep === AddNumberModalStep.Search ? (
                <NumberSearch {...props} />
            ) : modalStep === AddNumberModalStep.Select ? (
                <NumberSelect />
            ) : modalStep === AddNumberModalStep.Edit ? (
                <NumberEdit {...props} />
            ) : (
                <NumberConfirm />
            )}
        </Modal.Window>
    );
});
